import { useState } from 'react';
import { StatusFilter } from '../types';

export function useDirectoryFilters(defaultSort: string) {
    const [statusFilter, setStatusFilter] = useState<StatusFilter>(
        StatusFilter.ALL,
    );
    const [searchDraft, setSearchDraft] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [sortOption, setSortOption] = useState(defaultSort);
    const [selectedTags, setSelectedTags] = useState<string[]>([]);
    const [selectedVehicleTypes, setSelectedVehicleTypes] = useState<string[]>(
        [],
    );

    const knownParam =
        statusFilter === StatusFilter.RECOGNIZED
            ? true
            : statusFilter === StatusFilter.UNKNOWN
              ? false
              : undefined;

    return {
        statusFilter,
        setStatusFilter,
        searchDraft,
        setSearchDraft,
        searchQuery,
        setSearchQuery,
        sortOption,
        setSortOption,
        selectedTags,
        setSelectedTags,
        selectedVehicleTypes,
        setSelectedVehicleTypes,
        knownParam,
    };
}
